module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-events text-dark"
  }, [(_vm.type === 'swap') ? [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.swap_headline')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.swap_desc')))]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#f6f9fc"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? [_c('Tabs', {
    staticClass: "marg-1-top marg-1-bottom",
    attrs: {
      "tabs": _vm.tabs,
      "selected": _vm.selectedTab
    },
    on: {
      "select": _vm.selectTab
    }
  }), _vm._v(" "), (!_vm.isLoading && _vm.filteredEventsVProps.length < 1) ? _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.edit_event.swap_no_lessons')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.filteredEventsVProps), function(event) {
    return _c('li', {
      key: event.id,
      staticClass: "d-event",
      style: ({
        'backgroundColor': event.color
      })
    }, [_c('div', {
      staticClass: "d-event__content"
    }, [_c('b', [_vm._v(_vm._s(event.vTitle) + ",")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(event.vDateAndTime))])]), _vm._v(" "), _c('button', {
      staticClass: "bttn",
      class: {
        'bttn--loading': _vm.isSubmittingEventId === event.id
      },
      on: {
        "click": function($event) {
          return _vm.eventSwap(event)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.edit_event.select')) + "\n          ")])])
  }), 0)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.type === 'replace') ? [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.replace_headline')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.replace_desc')))]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#f6f9fc"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.subjects.length < 1) ? _c('p', {
    staticClass: "text-explainer marg-2-top"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.edit_event.replace_no_lessons')) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('ul', _vm._l((_vm.subjectsVProps), function(subject) {
    return _c('li', {
      key: subject.id,
      staticClass: "d-subject",
      style: ({
        'backgroundColor': subject.color
      })
    }, [_c('div', [_vm._v(_vm._s(subject.vTitle))]), _vm._v(" "), _c('button', {
      staticClass: "bttn",
      class: {
        'bttn--loading': _vm.isSubmittingSubjectId === subject.id
      },
      on: {
        "click": function($event) {
          return _vm.replaceEvent(subject)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.edit_event.select')) + "\n        ")])])
  }), 0) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5223cada!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/EventSwapOrReplace.vue
// module id = 1918
// module chunks = 1